import SendIcon from '@mui/icons-material/Send';
import { IconButton, useTheme } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import { useCallback } from 'react';
import { useLoadingBarState } from '../../../../../components/LoadingBar/LoadingBarContext';
import { IKPIRequestDataModel } from '../../../../../data-models/kpi-requests.data-model';
import { PermissionKey } from '../../../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../../../services/PermissionService';
import { useKPIRequestsNotSentActions } from '../hooks/useKPIRequestsNotSentActions';
import { MoreRequestOptionsButton } from './DeleteRequest';
import { ActionIndicatorSlot, RequestActionsRow } from './RequestActionsRow';

export default function UnsentReqsActionsRenderer(params: ICellRendererParams<IKPIRequestDataModel>) {
  const permSvc = PermissionService.get();
  const { colors } = useTheme();
  const {
    state: { isLoading },
  } = useLoadingBarState();
  const { sendKPIRequestAction } = useKPIRequestsNotSentActions();

  const handleOnSendRequest = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (!params?.data?.id) {
        return;
      }
      sendKPIRequestAction({
        requestsIds: [params?.data?.id],
      });
    },
    [params?.data?.id, sendKPIRequestAction]
  );

  if (params?.node?.group) {
    return null;
  }

  return permSvc.hasPermission(PermissionKey.canWriteDataCollection) ? (
    <RequestActionsRow>
      <IconButton
        onClick={handleOnSendRequest}
        disabled={isLoading}
        color='secondary'
        size={'medium'}
        title='send'
      >
        <SendIcon sx={{ color: colors.primary[60] }} />
      </IconButton>
      <ActionIndicatorSlot />
      <MoreRequestOptionsButton request={params.data} />
    </RequestActionsRow>
  ) : null;
}
